/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingScoresAnyOf } from './gradingScoresAnyOf';

export type GradingScores = GradingScoresAnyOf | null;
